import React, { FC } from 'react';
import { ConsentCheckListCheckboxProps } from './ConsentsListItem.types';
import { ConsentCheckListItem } from '../../../../molecules/ConsentCheckListItem';
import { ConsentSectionType } from '../../LegalConsents.types';

export const ConsentCheckList: FC<ConsentCheckListCheckboxProps> = ({
  consentData,
  consentSectionType,
  validateErrors,
  onModalOpen,
  onCheckboxToggle,
  onLinkClickInCheckbox,
}) => {
  const showErrorField = validateErrors && consentSectionType === ConsentSectionType.Required;
  return (
    <>
      {consentData.checkboxes.map(checkbox => (
        <ConsentCheckListItem
          key={`checkbox-${checkbox.id}`}
          label={checkbox.label.markdown}
          errorLabel={checkbox.errorMessage}
          termsBtnLabel={checkbox.termsLinkLabel}
          termsLink={checkbox.termsLink}
          selectedConsentId={consentData.id}
          id={checkbox.id}
          className={checkbox.checkboxClassNameOverride ?? checkbox.checkboxClassName}
          checkboxContainerClassName={
            checkbox.checkboxContainerClassName ?? checkbox.checkboxContainerClassNameOverride
          }
          checkboxLabelContainerClassName={`js-checkbox-label ${
            checkbox.checkboxLabelContainerClassNameOverride ?? checkbox.checkboxLabelContainerClassName ?? ''
          }`}
          name={checkbox.name}
          isChecked={checkbox.checked}
          showCheckbox={checkbox.showCheckbox}
          onModalOpen={onModalOpen}
          onChange={onCheckboxToggle}
          onLinkClickInCheckbox={onLinkClickInCheckbox}
          linkClass={checkbox.termsLinkLabelClassNameOverride ?? checkbox.termsLinkLabelClassName}
          linkTarget={checkbox.termsLinkTarget || ''}
          errorMessageClassName={
            consentData.errorMessageClassNameOverride ?? `m-checkbox-error ${consentData.errorMessageClassName ?? ''}`
          }
          validateErrors={showErrorField}
        />
      ))}
    </>
  );
};
